


















































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import SingleLetterMobile from './SingleLetterMobile/SingleLetterMobile.vue'
import * as api from '@/store/api'
import {Letter} from '@/store/models/Letter/Letter'
import { getNewGuid } from '@/util/utils';
import LetterFilterMobile from './LetterFilterMobile/LetterFilterMobile.vue';
import LetterSearchMobile from './LetterSearchMobile/LetterSearchMobile.vue';
import LetterTypeSelectorMobile from './LetterTypeSelectorMobile/LetterTypeSelectorMobile.vue';
import * as workflowService from '@/store/Services/workflowService';
import { Workflow } from '../../../store/models/workflow/workflow';
import store from '@/store'
import { LetterSearchResult } from '../../../store/models/Letter/LetterSearchResult';
import SearchResultItemMobile  from '@/components/MobileComponents/SearchResultListMobile/SearchResultItemMobile/SearchResultItemMobile.vue';
import * as letterService from '@/store/Services/letterServices';
import { DraftLetter } from '../../../store/models/Letter/DraftLetter';

@Component({
    components:{SingleLetterMobile,SearchResultItemMobile, LetterFilterMobile, LetterSearchMobile,LetterTypeSelectorMobile}
})
export default class LetterListMobile extends Vue{
    @Prop() lettersProp?: Letter[];
    @Prop() searchResultsProp?: LetterSearchResult[];
    @Prop() loading?: boolean;
    @Prop() mode?: string;
    @Prop() years?: number[];
    @Prop() defaultDate?: any;
    @Prop() serverTime?: string;
    isLoading=false;
    currentLetterType = 'all';
    currentSearchText = '';
    letters: Letter[] = [];
    searchResults: LetterSearchResult[] = [];
    usedWorkFlows: Workflow[] = [];
    filteredFormIds: string[] = [];
    curretnFilterMode = 'all';
    counts = {all: 0,notRead: 0 , notForwarded: 0  , forms: 0 , notForms: 0 , draftSent: 0 , draftNotSent: 0 };
    filter = (x: Letter) => {return true;};
    searchResultsFilter = (x: LetterSearchResult) => {return true;};

    @Watch('letters')
    onLettersChanged(){
        this.setUsedEnterpriseForms();
        this.calcCounts();
       
    }

    @Watch('searchResults')
    onSearchResultsChanged(){
        this.setUsedEnterpriseForms();
        this.calcCounts();
    }

    @Watch('filteredLetters')
    calcCounts(){
        if(this.filteredLetters.length >0){
            const all =  this.filteredLetters.length;
            const notRead = this.filteredLetters.filter(l=>!l.isOpenned).length;
            const notForwarded = this.filteredLetters.filter(l=>!l.isForwarded && l.isMainPossession).length;
            const forms = this.filteredLetters.filter(l=>l.isEnterpriseForm).length;
            const notForms = all - forms;
            
            const obj = {all: all,notRead: notRead , notForwarded: notForwarded , forms: forms , notForms: notForms, draftNotSent: 0 , draftSent: 0 };
            if(this.mode === 'drafts'){
                obj.draftSent = this.letters.filter(l=>{
                    const dLetter =  (l as DraftLetter)
                    if(dLetter.childLetters){
                        return dLetter.childLetters.length > 0
                    }
                    else{
                        return false;
                    }
                }).length;
                obj.draftNotSent = obj.all - obj.draftSent;
            }
            this.$emit('count-calcuted', obj)
            this.counts = obj;
        }
        else if(this.searchResults.length >0){
            const all =  this.searchResults.length;
            const notRead = this.searchResults.filter(l=>!l.isOpenned).length;
            const notForwarded = this.searchResults.filter(l=>!l.isForwarded).length;
            const forms = this.searchResults.filter(l=>l.isEnterpriseForm).length;
            const notForms = all - forms;
            const obj = {all: all,notRead: notRead , notForwarded: notForwarded , forms: forms , notForms: notForms, draftSent: 0 , draftNotSent: 0};
            this.$emit('count-calcuted', obj)
            this.counts = obj;
        }
    }

    @Watch('lettersProp')
    onLettersPropChanged(newVal: Letter[],oldVal: Letter[]){
        this.letters.length = 0;
        this.letters.push(...newVal);
    }
    @Watch('searchResultsProp')
    onSearchResultsPropChanged(newVal: LetterSearchResult[],oldVal: LetterSearchResult[]){
        this.searchResults.length = 0;
        this.searchResults.push(...newVal);
    }

    onLetterSelected(id: string){
        let index = 0;
        const tempLetter: any = {};
        let selectedLetter: any = {};
        if(this.letters && this.letters.length > 0){
            this.letters.forEach((item,i)=>{
                item.isSelected = false;
                if(item.letterPossessionId === id){
                    index = i;
                    Object.assign(tempLetter,item);

                }
            });

            tempLetter.isSelected = true;
            this.$set(this.letters,index,tempLetter);
            selectedLetter =  this.letters.find(item=>item.letterPossessionId === id);
        }
        if(this.searchResultsProp && this.searchResultsProp.length >0){
            this.searchResultsProp.forEach((item,i)=>{
                item.isSelected = false;
                if(item.possessionId === id){
                    index = i;
                    Object.assign(tempLetter,item);
                    
                }
            });
    
            tempLetter.isSelected = true;
            this.$set(this.searchResultsProp,index,tempLetter);
            selectedLetter =  this.searchResultsProp.find(item=>item.possessionId === id);
        }
        this.$emit("selected-letter-changed",selectedLetter);
        
        
    }

    onSearch(searchText: string){
           try {
        this.isLoading=true;
        setTimeout(() => {
            this.currentSearchText = searchText;
            this.updateFilter();
        }, 1000);

        } catch (error) {
            console.log(error);            
        }
    }

    onFormSelection(selection: any){
        if(selection.isSelected){
            this.filteredFormIds.push(selection.formId);
        }else{
            const index =  this.filteredFormIds.indexOf(selection.formId);
            if(index > -1){
                this.filteredFormIds.splice(index,1);
            }
        }
        this.onFilterModeChanged(this.curretnFilterMode);
    }

    FilterForSearch(letter: Letter): boolean{
        return letter.letterNo.includes(this.currentSearchText) 
        || this.replaceChars(letter.title).includes(this.currentSearchText) 
        || this.replaceChars(letter.abstract).includes(this.currentSearchText) 
        || (letter.sender !== undefined && letter.sender !== null && this.replaceChars(letter.sender.name).includes(this.currentSearchText) )
        || (letter.recievers !== null && letter.recievers !== undefined && letter.recievers.filter(item=>this.replaceChars(item.name).includes(this.currentSearchText)).length>0)
        
    }

    SearchResultsFilterForSearch(searchResult: LetterSearchResult): boolean{
        return searchResult.letterNo.includes(this.currentSearchText) 
        || this.replaceChars(searchResult.title).includes(this.currentSearchText) 
        || this.replaceChars(searchResult.abstract).includes(this.currentSearchText) 
        || (searchResult.from !== undefined && searchResult.from !== null && this.replaceChars(searchResult.from.name).includes(this.currentSearchText) )
        || (searchResult.to !== null && searchResult.to !== undefined && searchResult.to.filter(item=>this.replaceChars(item.name).includes(this.currentSearchText)).length>0)
    }

    filterForLetterState(letter: Letter): boolean {
        if(this.currentLetterType === 'notRead'){
            return  !letter.isOpenned;
            
        }
        else if(this.currentLetterType === 'notForwarded'){
            return  !letter.isForwarded && letter.isMainPossession;
        }
        else if(this.currentLetterType === 'sent'){
            const draftLetter =  letter as DraftLetter;
            if(draftLetter.childLetters)return draftLetter.childLetters.length >0;
            else return false;

        }
        else if(this.currentLetterType === 'notSent'){
            const draftLetter =  letter as DraftLetter;
            if(draftLetter.childLetters)return draftLetter.childLetters.length === 0;
            else return false;
        }
        else if(this.currentLetterType === 'all'){
            return  true;
        }
        
        return true;
        
    }

    filterForLetterType(letter: any): boolean {
          if(this.curretnFilterMode === 'forms'){
            if(this.filteredFormIds.length > 0){
                return letter.isEnterpriseForm && (this.filteredFormIds.indexOf(letter.enterpriseFormId) > -1) ;
            }
            else{
                return letter.isEnterpriseForm;
            }
            

        }else if(this.curretnFilterMode === 'notForms'){
            return !letter.isEnterpriseForm;
        }
        return true;
    }

    

    replaceChars(inputStr: string): string{
        
       inputStr = inputStr.replace(/ي/g, "ی");
       inputStr = inputStr.replace(/ۍ/g, "ی");
       inputStr = inputStr.replace(/ێ/g, "ی");
       inputStr = inputStr.replace(/ۑ/g, "ی");
       inputStr = inputStr.replace(/ې/g, "ی");
       inputStr = inputStr.replace(/ك/g, "ک");
       inputStr = inputStr.replace(/ګ/g, "ک");
       inputStr = inputStr.replace(/ڬ/g, "ک");
       inputStr = inputStr.replace(/ڇ/g, "چ");
        return inputStr;
    }

    async refresh(){
        this.$forceUpdate();

    }

    get filteredLetters(){
        return  this.letters.filter(this.filter)
        
    }

    get filteredSearchResults(){
        return this.searchResults.filter(this.searchResultsFilter);
    }

    updateFilter(){
        this.filter = (letter) =>  this.FilterForSearch(letter) && this.filterForLetterState(letter) && this.filterForLetterType(letter);
        this.searchResultsFilter = (searchResult) => this.SearchResultsFilterForSearch(searchResult) && this.filterForLetterType(searchResult);
        this.isLoading=false;
     }

   

    onLetterTypeChanged(mode: string){
        
        this.calcCounts();
        this.currentLetterType = mode;
        this.updateFilter();
        

    }

    onFilterModeChanged(mode: string){
        this.curretnFilterMode = mode;
        this.updateFilter();
    }

    async created(){
        if(store.state.workflows.length === 0)
        {
            const workflows =  await workflowService.getAllWorkflowsWithEnterpriseForms();
            store.commit("setWorkflows",workflows);
        }
        store.state.eventHub.$on('calc-letterscount-requested',this.calcCounts);
        store.state.eventHub.$on('dependent-letter-sent',this.onDependentLetterSent);
        store.state.eventHub.$on('closeFastEvent',this.closeLetter);
        store.state.eventHub.$on('rejectCloseLetterEvent',this.rejectCloseLetter);
        store.state.eventHub.$on('forwardLetterEvent',this.forwardLetter);
        store.state.eventHub.$on("form-selection",this.onFormSelection);

        
        //this.serverTime = await letterService.getServerTime();
        
    }
    onDependentLetterSent(letterPossessionId: string){
        // if(!this.lettersProp)return;
        // const letter =  this.lettersProp.find(l=>l.id == letterPossessionId); 
        // if(!letter)return;
        // letter.isForwarded = true;
        this.forwardLetter(letterPossessionId);
        
    }
    setUsedEnterpriseForms(){
        const enterpriseForms =  this.letters.filter(letter=>letter.isEnterpriseForm);
        const distinctForms: Letter[] = [];
        enterpriseForms.forEach(form => {
            const item =  distinctForms.find(x=>x.enterpriseFormId === form.enterpriseFormId);
            if(item === undefined){
                distinctForms.push(form);
            }
        });
        this.usedWorkFlows.length = 0;
        const allWorkflows = store.state.workflows as Workflow[];
        distinctForms.forEach(letter=>{
            allWorkflows.forEach(wf=>{
                if(wf.enterpriseForms != null && wf.enterpriseForms != undefined){
                    const form = wf.enterpriseForms.find(ef=>ef.id === letter.enterpriseFormId);
                    if(form != undefined){
                        let usedWorkflow = this.usedWorkFlows.find(uwf=>uwf.id === wf.id);
                        if(usedWorkflow === undefined){
                            usedWorkflow = {id: wf.id , name: wf.name , enterpriseForms: []} as Workflow;
                            this.usedWorkFlows.push({id: wf.id , name: wf.name , enterpriseForms: []});
                        }
                        usedWorkflow = this.usedWorkFlows.find(uwf=>uwf.id === wf.id);
                            if(usedWorkflow != undefined){
                            if(usedWorkflow.enterpriseForms !== undefined && usedWorkflow.enterpriseForms !== null){
                                usedWorkflow.enterpriseForms.push(form);
                            }
                        }

                    }
                }
            });
        });
    }

    onDateFilterChanged(date: any){
        this.$emit('date-filter-changed',date);
    }

    onSortModeChanged(mode: string){
        if(mode === 'title') this.letters = this.letters.sort((l1,l2)=>l1.title.localeCompare(l2.title));
        if(mode === 'date') this.letters = this.letters.sort((l1,l2)=> (new Date(l2.sendTime).getTime() - (new Date(l1.sendTime)).getTime()));
        if(mode === 'sender') this.letters = this.letters.sort((l1,l2)=>{
            if(l1.sender === null || l1.sender === undefined) return 0;
            if(l2.sender === null || l2.sender === undefined) return 0;
            return l1.sender.name.localeCompare(l2.sender.name);
        });
    }

    closeLetter(possessionId: string){

        const letter =  this.letters.find(item=>item.letterPossessionId === possessionId);
        if(letter)
            this.letters[this.letters.indexOf(letter)].isClosed = true;
        else{
            const searchResult = this.searchResults.find(item=>item.possessionId === possessionId);
            if(searchResult)
                this.searchResults[this.searchResults.indexOf(searchResult)].isClosed = true;
                
        }
        
    }

     rejectCloseLetter(possessionId: string){

        const letter =  this.letters.find(item=>item.letterPossessionId === possessionId);
        if(letter)
            this.letters[this.letters.indexOf(letter)].isClosed = false;
        else{
            const searchResult = this.searchResults.find(item=>item.possessionId === possessionId);
            if(searchResult)
                this.searchResults[this.searchResults.indexOf(searchResult)].isClosed = false;
        }
        

    }

    forwardLetter(possessionId: string){
         const letter =  this.letters.find(item=>item.letterPossessionId === possessionId);
        if(letter)
            this.letters[this.letters.indexOf(letter)].isForwarded = true;
        else{
            const searchResult = this.searchResults.find(item=>item.possessionId === possessionId);
            if(searchResult)
                this.searchResults[this.searchResults.indexOf(searchResult)].isForwarded = true;
        }
    }

    resetTypeSelector(){
        if(this.mode === 'drafts')
        (this.$refs.typeSelector as any).selectNotSentMode();
        else if(this.mode === 'received')
        (this.$refs.typeSelector as any).selectAllMode();
    }
   
}

